export default __webpack_public_path__ + "static/media/15_Ds.a13eee11.svg";